<template>
  <d-modal
    size="lg"
    @close="closePopup">
    <d-modal-header>
      <d-modal-title>
        {{ $t('dashboard.customersPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="py-0 px-3 pb-3">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">
              {{ $t('dashboard.customersPopup.customerName') }}
            </th>
            <th scope="col" class="border-0">
              {{ $t('dashboard.customersPopup.customerPhone') }}
            </th>
            <th scope="col" class="border-0">
              {{ $t('dashboard.customersPopup.customerEmail') }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(customerData, index) of customersData"
            :key="'customers-data-' + index">
            <td class="align-middle">
              {{ customerData.name }}<br>
              <small>{{ $t('dashboard.customersPopup.averageOrderTime', { days: customerData.average }) }}</small>
            </td>
            <td class="align-middle">
              {{ customerData.phone }}
            </td>
            <td class="align-middle">
              {{ customerData.email }}
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'customers-popup',
  props: [
    'customersData'
  ],
  methods: {
    closePopup () {
      this.$bus.$emit('dashboard-customers-popup-close');
    }
  }
}
</script>
